module.exports = __webpack_public_path__ + "img/preview-3.805f8c4c.webp";